import { OrderPaymentStatus } from 'models'

export enum ColorVariant {
    Success,
    Warning,
    Error,
    Info,
    Default,
}

export const DarkColor = {
    [ColorVariant.Default]: '#999999',
    [ColorVariant.Success]: 'primary.main',
    [ColorVariant.Warning]: 'warning.main',
    [ColorVariant.Error]: 'error.main',
    [ColorVariant.Info]: 'info.main',
}

export function paymentStatusColor(
    status: OrderPaymentStatus,
    isReturnedCredit: boolean = false,
): string {
    if (isReturnedCredit) return DarkColor[ColorVariant.Info]
    switch (status) {
        case OrderPaymentStatus.Paid:
            return DarkColor[ColorVariant.Success]
        case OrderPaymentStatus.Pending:
            return DarkColor[ColorVariant.Warning]
        case OrderPaymentStatus.Refunded:
            return DarkColor[ColorVariant.Error]
        case OrderPaymentStatus.Voided:
            return DarkColor[ColorVariant.Default]
        default:
            return DarkColor[ColorVariant.Default]
    }
}

export const OnlineStatusColors = {
    Online: '#55F000',
    Offlne: '#9EA7AC',
}
